// extracted by mini-css-extract-plugin
export default {"aboutPage":"About_aboutPage__bR+3x","awsInfo":"About_awsInfo__syh87","introContainer":"About_introContainer__EZv4Q","about":"About_about__r4lqp","photo":"About_photo__Fa69m"};